<ubi-dialog #dialog>
  <div ubi-dialog-header>
    {{data.title}}
  </div>
  <div ubi-dialog-content>
    {{data.message}}
  </div>
  <div ubi-dialog-action>
    <button *ngIf="data.type ==='confirm'" (click)="close()" class="btn btn_small btn_rounded dialog-btn" mat-button
      ubi-round-button>CANCEL</button>
    <button *ngIf="data.type ==='confirm'" (click)="submit()" class="btn btn_small btn_accent-gradient-rounded dialog-btn" mat-button
      ubi-round-button type="submit">OK</button>
    <button *ngIf="data.type ==='alert'" (click)="close()" class="btn btn_small btn_accent-gradient-rounded dialog-btn" mat-button
      ubi-round-button type="submit">CLOSE</button>
  </div>
</ubi-dialog>
